import { useForm } from 'react-hook-form';
import { Navigate, useNavigate } from 'react-router-dom';
import { Box, Button, PasswordInput, TextInput } from '@mantine/core';
import api from '../../api/api';
import { useAuth } from '@/AuthProvider';
import { PreAuth } from '@/components/PreAuth/PreAuth';
import { displayErrorOnReactHookForm } from '@/utils/error/errorHandler';
import { isEmpty } from '@/utils/functions';

interface FormValues {
  email: string;
  password: string;
}

export const LoginPage = (): JSX.Element => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<FormValues>();
  const navigate = useNavigate();
  const { setToken, token } = useAuth();

  if (token) {
    return <Navigate to="/my-account" />;
  }

  const onSubmit = handleSubmit(async (data: FormValues) => {
    try {
      const credentials = btoa(`${data.email}:${data.password}`);
      const response = await api.post('/auth/login', null, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });
      setToken(response.data.accessToken);
      navigate('/my-account');
    } catch (error: any) {
      displayErrorOnReactHookForm(error, setError);
    }
  });

  return (
    <PreAuth>
      <form
        onSubmit={onSubmit}
        className="flex flex-col justify-center items-center w-full gap-4 pt-12 pb-24"
      >
        <TextInput
          {...register('email', {
            validate: match => {
              const emailRegex =
                /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
              if (isEmpty(match)) return 'Toto je povinné pole';
              if (!emailRegex.test(match))
                return 'Nespravný format emailové adresy';
            },
          })}
          // TODO: move to config and switch based on env
          error={errors.email?.message}
          radius="md"
          size="md"
          variant="filled"
          maw="25rem"
          placeholder="E-mail"
          className="w-full"
        />
        <PasswordInput
          {...register('password', {
            validate: match => {
              if (isEmpty(match)) return 'Toto je povinné pole';
            },
          })}
          type="password"
          // TODO: move to config and switch based on env
          error={errors.password?.message}
          variant="filled"
          radius="md"
          size="md"
          maw="25rem"
          className="w-full"
          placeholder="Heslo"
        />
        <Button
          type="submit"
          maw="25rem"
          size="md"
          className="w-full rounded-lg text-lg"
        >
          Přihlásit se
        </Button>
        <Box maw="25rem" className="w-full">
          <a href="login/forgot-password" className="underline text-blue-600">
            Zapomenuté heslo
          </a>
        </Box>
      </form>
    </PreAuth>
  );
};
